import React, { useEffect } from 'react';
import { Flex, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Spinner, Text } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import CreateSalesForm from './CreateSalesForm';
import CreateLeadsForm from './CreateLeadsForm';
import { useGetAdsetFormQuery } from 'store/campaigns/adsetFormApi';
import { useGetcampaignByIdQuery } from 'store/campaigns/campaignsApi';
import CreateAdvantagePlusShoppingSalesForm from './CreateAdvantagePlusShoppingSalesForm';
import { selectCampaignDataLoading, setCampaignDataLoading } from 'store/campaigns/campaignsSlice';
import CreateAppPromotionForm from './CreateAppPromotionForm';
import CreateAwarenessForm from './CreateAwarenessForm';
import CreateEngagementForm from './CreateEngagementForm';
import CreateCatalogueSalesForm from './CreateCatalogueSalesForm';
import CreateTrafficForm from './CreateTrafficForm';


function CreateAdsetForm({ isOpen, onClose, adsAccountData, onSuccess }) {

  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search);
  const campaignType = queryParams.get('objective');
  const campaignId = queryParams.get('campaignIds');

  const isCampaignsDataLoading = useSelector(selectCampaignDataLoading);
  
  const { data: campaignData, isLoading:isCampaignLoading, refetch:refetchCampaigns} = useGetcampaignByIdQuery(
    {campaignId, adsAccountId:adsAccountData?.account_id},
    { skip: !campaignId }
  );

  const isCampaignReady = !isCampaignLoading && !!campaignData && !!campaignData[campaignId];
  
  const smartPromotionType = campaignData && campaignData[campaignId]?.smart_promotion_type === 'AUTOMATED_SHOPPING_ADS';

  const productCatalogId = isCampaignReady
    ? campaignData[campaignId]?.promoted_object?.product_catalog_id
    : undefined;

  const baseSkip = campaignType !== 'OUTCOME_SALES';

  const shouldSkipSales = !isCampaignReady || baseSkip || !!productCatalogId;
  const shouldSkipCatalogueSales = !isCampaignReady || baseSkip || !productCatalogId;


  // Only when NO product_catalog_id
  const { data: dataSales, error: errorSales, isLoading: isLoadingSales } = useGetAdsetFormQuery(
      { campaign_type: 'OUTCOME_SALES' },
      { skip: shouldSkipSales }
  );
  
  // Only when product_catalog_id is present
  const { data: dataCatalogueSales, error: errorCatalogueSales, isLoading: isLoadingCatalogueSales } = useGetAdsetFormQuery(
      {
      campaign_type: 'OUTCOME_SALES',
      promoted_object: { product_catalog_id: productCatalogId }
      },
      { skip: shouldSkipCatalogueSales }
  );

  const { data: dataLeads, error: errorLeads, isLoading: isLoadingLeads } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_LEADS' }, { skip: campaignType !== 'OUTCOME_LEADS' }); 
  const { data: dataAwareness, error: errorAwareness, isLoading: isLoadingAwareness } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_AWARENESS' }, { skip: campaignType !== 'OUTCOME_AWARENESS' }); 
  const { data: dataEngagement, error: errorEngagement, isLoading: isLoadingEngagement } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_ENGAGEMENT' }, { skip: campaignType !== 'OUTCOME_ENGAGEMENT' }); 
  const { data: dataTraffic, error: errorTraffic, isLoading: isLoadingTraffic } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_TRAFFIC' }, { skip: campaignType !== 'OUTCOME_TRAFFIC' }); 
  const { data: dataAppPromotions, error: errorAppPromotions, isLoading: isLoadingAppPromotions } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_APP_PROMOTION' }, { skip: campaignType !== 'OUTCOME_APP_PROMOTION' }); 
  const { data: dataAdvantageShopping, error: errorAdvantageShopping, isLoading: isLoadingAdvantageShopping } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_SALES', smart_promotion_type : 'AUTOMATED_SHOPPING_ADS' }, { skip: campaignType !== 'OUTCOME_SALES' || !smartPromotionType });
     

  useEffect(() => {
    if (isCampaignsDataLoading) {
            refetchCampaigns();
            dispatch(setCampaignDataLoading(false));
    }
}, [isCampaignsDataLoading]);

  const renderForm = () => {
    const errorMessage =
          errorSales?.data?.message ||
          errorLeads?.data?.message ||
          errorAppPromotions?.data?.message ||
          errorAwareness?.data?.message ||
          errorEngagement?.data?.message ||
          errorTraffic?.data?.message ||
          errorAdvantageShopping?.data?.message ||
          errorCatalogueSales?.data?.message ||
          "Failed to load ad set form data.";

    if (isLoadingSales || isLoadingLeads || isLoadingAppPromotions || isCampaignLoading || isLoadingAdvantageShopping || isLoadingAwareness || isLoadingEngagement || isLoadingTraffic || isLoadingCatalogueSales) {
        return (
          <Flex justify="center" align="center" height="70vh">
              <Spinner size="md" />
          </Flex>
        );
    }

    if (
      errorSales ||
      errorLeads ||
      errorAppPromotions ||
      errorAwareness ||
      errorEngagement ||
      errorTraffic ||
      errorAdvantageShopping ||
      errorCatalogueSales
    ) {
      return (
        <Flex direction={'column'} gap={2} color={'red.500'}>
          <Text fontWeight="bold">Error</Text>
          <Text fontSize="sm">{errorMessage}</Text>
        </Flex>
      );
    }

    if (campaignType === 'OUTCOME_SALES' && !smartPromotionType && dataSales?.data && campaignData) {
        return (
            <CreateSalesForm
                data={dataSales?.data}
                campaignData={campaignData}
                campaign_id={campaignId}
                adsAccountData={adsAccountData}
                onClose={onClose}
                onSaveSuccess={onSuccess}
            />
        );
    } else if (campaignType === 'OUTCOME_SALES' && !smartPromotionType && dataCatalogueSales?.data && campaignData) {
      return (
          <CreateCatalogueSalesForm
              data={dataCatalogueSales?.data}
              campaignData={campaignData}
              campaign_id={campaignId}
              adsAccountData={adsAccountData}
              onClose={onClose}
              onSaveSuccess={onSuccess}
          />
      );
    } else if (campaignType === 'OUTCOME_LEADS' && !smartPromotionType && dataLeads?.data && campaignData) {
        return (
            <CreateLeadsForm
                data={dataLeads?.data}
                campaignData={campaignData}
                campaign_id={campaignId}
                adsAccountData={adsAccountData}
                onClose={onClose}
                onSaveSuccess={onSuccess}
            />
        );
    } else if (campaignType === 'OUTCOME_SALES' && smartPromotionType  && dataAdvantageShopping && campaignData ) {
      return (
          <CreateAdvantagePlusShoppingSalesForm
              data={dataAdvantageShopping?.data}
              campaignData={campaignData}
              campaign_id={campaignId}
              adsAccountData={adsAccountData}
              onClose={onClose}
              onSaveSuccess={onSuccess}
          />
      );
    } else if (campaignType === 'OUTCOME_APP_PROMOTION' && !smartPromotionType  && dataAppPromotions && campaignData ) {
    return (
          <CreateAppPromotionForm
              data={dataAppPromotions?.data}
              campaignData={campaignData}
              campaign_id={campaignId}
              adsAccountData={adsAccountData}
              onClose={onClose}
              onSaveSuccess={onSuccess}
          />
    );
    } else if (campaignType === 'OUTCOME_AWARENESS' && !smartPromotionType  && dataAwareness && campaignData ) {
      return (
            <CreateAwarenessForm
                data={dataAwareness?.data}
                campaignData={campaignData}
                campaign_id={campaignId}
                adsAccountData={adsAccountData}
                onClose={onClose}
                onSaveSuccess={onSuccess}
            />
      );
    } else if (campaignType === 'OUTCOME_ENGAGEMENT' && !smartPromotionType  && dataEngagement && campaignData ) {
      return (
            <CreateEngagementForm
                data={dataEngagement?.data}
                campaignData={campaignData}
                campaign_id={campaignId}
                adsAccountData={adsAccountData}
                onClose={onClose}
                onSaveSuccess={onSuccess}
            />
      );
    } else if (campaignType === 'OUTCOME_TRAFFIC' && !smartPromotionType  && dataTraffic && campaignData ) {
      return (
            <CreateTrafficForm
                data={dataTraffic?.data}
                campaignData={campaignData}
                campaign_id={campaignId}
                adsAccountData={adsAccountData}
                onClose={onClose}
                onSaveSuccess={onSuccess}
            />
      );
    }
    return null;
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Create Adset</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {renderForm()}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default CreateAdsetForm;
